import { render, staticRenderFns } from "./classReport.vue?vue&type=template&id=4f104d44&scoped=true&"
import script from "./classReport.vue?vue&type=script&lang=js&"
export * from "./classReport.vue?vue&type=script&lang=js&"
import style0 from "./classReport.vue?vue&type=style&index=0&id=4f104d44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f104d44",
  null
  
)

export default component.exports